import { DateValue } from 'utils/dates';
import { DynamicOrder } from 'utils/dynamic';
import { FixServerObject } from 'utils/types';
import * as yup from 'yup';
import { ITenant, ITenantDynamicResponse } from '__generated__/api';

export const schemaTenants = yup.object({
  companyName: yup.string().required('rule-required').default(''),
  isActive: yup.boolean().default(true),
  logo: yup.mixed<string>().nullable().default(null),
  countryID: yup.string().required('rule-required').default(''),
});

export interface ITenantInput extends Omit<ITenant, 'logo'> {
  logo?: string | null | undefined;
}

export interface IGridTenant
  extends FixServerObject<Pick<ITenant, 'id' | 'countryID' | 'isActive' | 'companyName'>, 'id'> {
  countryName: string;
  countryFlag: string;
  logo: string;
}

export interface ITenantGridPageInput {
  search: string;
  isActive: boolean | null;

  take?: number;
  skip?: number;
  orderBy: DynamicOrder;
}

export interface IGridTenantResponse extends Omit<ITenantDynamicResponse, 'items'> {
  items: IGridTenant[];
}

export interface ITenantInfoResponse extends ITenant {
  tenantProductsCount: number;
  tenantIgnoreProductsCount: number;
  userTenantsCount: number;
  botSessionsCount: number;
  botCompletedSessionsCount: number;
  countryName: string;
}

interface BotSessions {
  createdDate: string;
  isSessionComplete: boolean;
}

export interface ITenantSessionsResponse {
  botSessions: BotSessions[];
}

export interface ITenantSessionsArgs {
  entryDate: DateValue[];
  id: string;
}
